export const config = {
  '360_PORTAL_URL':
    process.env.REACT_APP_360_PORTAL_URL || 'https://portal.dev.epilot.cloud'
}

/* export const config: {
  '360_PORTAL_URL': process.env.REACT_APP_360_PORTAL_URL || 'https://portal.staging.epilot.cloud'
} */

/* export const config: {
  '360_PORTAL_URL': process.env.REACT_APP_360_PORTAL_URL || 'https://portal.epilot.cloud'
} */
